import { Subject,  EMPTY, race, timer } from 'rxjs';
import { shareReplay, catchError, switchMap } from 'rxjs/operators';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild,ChangeDetectorRef, TemplateRef, ViewContainerRef, ChangeDetectionStrategy, AfterViewInit, AfterViewChecked , NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT, NgFor, NgForOf, NgTemplateOutlet } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Observable } from 'rxjs/internal/Observable';

// models ==========================================================================


// prime ng components ---------------------------------------------------------------
import { Table, TableModule, TablePageEvent, TableService } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenuItem, MessageService, SelectItem, ConfirmationService} from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { InputGroupModule } from 'primeng/inputgroup';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { IconFieldModule } from 'primeng/iconfield';
import { DropdownModule } from 'primeng/dropdown';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputTextModule } from 'primeng/inputtext';

// Random -----------------------------------------------------------------------------
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

// OUR COMPONENTS -------------------------------
import { filter } from 'lodash';
import { CheckboxModule } from 'primeng/checkbox';
import { ListboxClickEvent, ListboxModule } from 'primeng/listbox';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { GenericButtonComponent } from '../../../../../global/component/generic/generic-button/generic-button.component';
import { EventModalComponent } from '../../../../shared-components/event-modal/event-modal.component';
import { TableFilterComponent } from '../../../../../global/component/generic/table-filter/table-filter.component';
import { LoadingSpinnerComponent } from '../../../../../global/component/loading-spinner/loading-spinner.component';
import { GenericTextInputComponent } from '../../../../../global/component/generic/generic-text-input/generic-text-input.component';
import PagingModel from '../../../../../global/model/PagingMoel';
import { DisplayColumn, FilterModel, FilterOperators, LookupFilter, SearchModel } from '../../../../../global/model/SearchModel';
import { EventModel } from '../../../../models/EventModel';
import { EventService } from '../../../../services/event.service';
import { MainModel } from '../../../../../global/model/MainModel';
import { UserPermissionsService } from '../../../../../global/services/permissions/UserPermissionsService';
import { TableDataType } from '../../../../../global/model/ExportColumn';
import { MatchType } from '../../../../../global/model/search/MatchType';
import { ServerClientService } from '../../../../../global/services/data/campaign-service/server-client.service';
import { SearchService } from '../../../../../global/services/data/search-service/searchservice';
import { exportToExcel, outputProperDisplayFormat } from '../../../../../global/util/util';

@Component({
  selector: 'rc-donor-donations-list-report',
  standalone: true,
  imports: [TableModule, SplitButtonModule, InputTextModule, CheckboxModule, CalendarModule,
    DropdownModule, CommonModule, NgFor, NgForOf, DialogModule,
    ButtonModule, FormsModule, MultiSelectModule, ToggleButtonModule, MenuModule, GenericButtonComponent,
    ToastModule, TagModule, InputGroupModule, InputIconModule, IconFieldModule, CardModule, ListboxModule,
    DialogModule, GenericTextInputComponent, LoadingSpinnerComponent, EventModalComponent, TableFilterComponent,ConfirmDialogModule],
  providers: [MessageService,ConfirmationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './donor-donations-list-report.component.html',
  styleUrl: './donor-donations-list-report.component.scss'
})
export class DonorDonationsListReportComponent implements OnInit, AfterViewInit, AfterViewChecked { // AfterViewInit  

  // global pull down options for the new range fileters ------------

  // Local state ----------------------------------------------------
  isExpandedView = false;
  showLoading: boolean = false;
  maxSelected:number = 20 ;
  searchPerformed:boolean = false;
  get hasResults(){ return this.data?.length > 0 };
  allItemsChecked:boolean = false;

  // modal =========================================================
  confirmAction:string|null = null;
  showConfirmModal:boolean = false;
  lastClicked:any = null;
  lastSearch:any = undefined;

  // MODELS ========================================================
  pagingModel: PagingModel = new PagingModel();
  columnData: SearchModel = {
    displayColumns: [],
    states: [],
    fundCodes: [],
    commonFilters: [],
    textFilters: [],
    rangeFilters: [],
    amountFilters: [],
    statusOptions: [],
    approvalOptions: [],
    fundraisers: [],
    sources: [],
    events: [],
    checkbooks: [],
    dateFilters: [],
    batchTypes: []
  };

  @Input({ required: !true }) dataType: TableDataType = TableDataType.Report_Donor_Donations;
  
  // OUTPUTS ========================================================
  @Output() dataViewUpdate = new EventEmitter<PagingModel>();

  // data from the back end...
  data: DisplayColumn[]               = [];
  fallsBackApi:boolean = false;

  // columns --------------------------------------------------------
  defaultColumns: DisplayColumn[]     = [];  // the default displayed columns for this search...
  selectedColumns: DisplayColumn[]    = [];  // the selected displayed columns for this search...
  checkedColumns: DisplayColumn[]    = [];  // the selected displayed columns for this search...
  get resultsColspan(){ return this.selectedColumns.length + 2};
  balanceFrozen: boolean              = true;
  
  // filters composed on the server side ----------------------------
  filterString:string                 = ""; // built from filters...
  filterModel:any                     = {}; // contains values
  groupedDisplayColumns:Array<any>    = [];

  addEventModel:EventModel            = new EventModel();
  showAddEventModal:boolean           = false;
  eventTypes:Array<any>               = [];

  // new data structure to allow for binding to filters outside the table...
  filters:any                         = {};
  
  // filter data structures composed on the client side ----------------------------
  selectedOptions: MenuItem[]         = [];
  numberOfItemsSelected:number = 0;

  // BEHAVIOR CHANGING INPUTS =======================================
  @Input() public validateSubmit: boolean = true;
  @Input() showInDialog: boolean = false;

  // TEMPLATES ========================================================
  @Input() public tableBodyTemplate!: TemplateRef<any>;
  @Input() public topButtonTemplate!: TemplateRef<any>; // this isnt currently used all the table headers are the same but here for future possible use...
  @Input() public tableHeadersTemplate!: TemplateRef<any>; // this isnt currently used all the table headers are the same but here for future possible use...

  // VIEW CHILD ========================================================
  @ViewChild('container', { read: ViewContainerRef }) container!: ViewContainerRef;
  @ViewChild('resultstable') public resultstable!: Table;

  private destroySearch$ = new Subject<void>();

  // Vortex2 Column Order - This is important to keep the columns in a consistent order for users.
  static COLUMN_ORDER = [
    "DonorID", "DonorTypeID", "Organization", "Prefix", "FirstName", "InformalName", "LastName", "MiddleName", "Suffix",
    "ReceiptAmount", "HomePhone", "OfficePhone", "CellPhone", "Fax", "Email", "Address1", "Address2", "City",
    "StateID", "Zip", "HomeCounty", "Country", "Employer", "Occupation", "DoNotSolicit", "DonationRecord", "Pledge",
    "DonationDate", "DonationMonth", "DonationQtr", "DonationSourceID", "DonationMethod", "CheckNumber", "FundraiserID", "AdditionalFundraiser",
    "EventID", "EventName", "IsBundled", "BundleOrg", "FEC", "DIT", "Chargeback", "NSF", "CampaignYear", "FundType",
    "GrossReceiptAmt", "RefundAmount", "NetReceiptAmount", "CorrectiveAction", "BatchName", "BatchDate", "CheckbookID",
    "DonationEntryDate", "Spouse", "IsDeceased", "LegacyRecordId", "SourceTrxId", "LastEditTimeStamp", "Campaign", "IsMemo", "ParentDonationID"
  ];

  constructor(
    @Inject(DOCUMENT) private document: Document,
    protected searchService:SearchService,
    private eventsService:EventService,
    protected messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    protected serverClient: ServerClientService,
    protected model: MainModel, 
    private activeRoute: ActivatedRoute,
    protected permissions:UserPermissionsService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone 
  ) {

  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  // LIFE CYCLE METHODS TO OVERRIDE ==================================================================================
  
  /***
   * Overriding classes can use this hook as well - just make sure to call super.ngOnInit() first.
   */
  ngOnInit() {
    
    this.dataType = TableDataType.Report_Donor_Donations;

    this.selectedOptions = [
      { label: 'Activate', icon: 'fa-sharp fa-light fa-thumbs-up', command: () => {
        this.lastClicked = null;
        if(this.howManyChecked() > 0){
          this.openActionDialog(null, 'Activate');
        }
      } },
      { label: 'Inactivate', icon: 'fa-sharp fa-light fa-thumbs-down', command: () => {
        this.lastClicked = null;
        if(this.howManyChecked() > 0){
          this.openActionDialog(null, 'InActivate');
        }
      } },
      { label: 'Delete', icon: 'fa-sharp fa-light fa-trash-can', command: () => {
        this.lastClicked = null;
        if(this.howManyChecked() > 0){
          this.openActionDialog(null, 'Delete');
        }
      } }
    ];
  
    const customFilterName = '_equals';
    this.initializeColumns();
  }
  
  
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnChanges() {
    this.cdr.detectChanges();
  }


  // ngAfterViewInit() {
  //   this.container.createEmbeddedView(this.tableBodyTemplate);
  // }

  groupColumnsBy(groupByField: keyof DisplayColumn) {
    const groups: any = {};
    this.columnData.displayColumns.forEach(column => {
      const group = column[groupByField] as string;
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(column); // Pass entire DisplayColumn object as value
    });

    this.groupedDisplayColumns = Object.keys(groups).map(group => ({
      label: group,
      value: group,
      items: groups[group].map((i:any) => {
        const x:any = {};
        x.label = i.displayColumn;
        x.value = i;
        return x;
      }
    )
    }));
  }

  /**
   * 
   * @param obj 
   */
  getBlankFilter(obj:any):FilterModel{
    let filterModel:FilterModel = new FilterModel(obj);
    delete obj.options;
    return filterModel as FilterModel;
  }

  getDisplayValue(item:any, col:DisplayColumn){
      return outputProperDisplayFormat(item[col.columnName]);
  }

  /**
   * Gets the generalized data structures that defines table columns, column types, etc... from the back end. 
   * Also sets the values into the local model for displaying filters. 
   * @returns 
   */
  initializeColumns() {
    if(this.dataType === TableDataType.TBD){
      console.debug("TABLE TYPE NEEDS TO BE SET IN ORDER TO SET AND SEARCH DATA IN THSI TABLE.....");
      return;
    }
    const id = this.model?.selectedCampaign()?.campaignId;
    if(id){
      // donation search...
      this.serverClient.getDataTableData(this.dataType || TableDataType.Report_Donor_Donations, this.pagingModel, id).subscribe(
        (data: SearchModel) => {
          this.columnData = data;
          // build model buckets for the range filters...
          this.columnData.displayColumns.forEach((i:DisplayColumn) => {
            const fltr = this.getBlankFilter(i);
            if(fltr.isFilterable === true){
              i.filterModel = fltr;
              this.filters[i.columnName] = i;
            }
          });

         // LEAVING IN COMMENT TO USE FOR FUTURE COMPARE FOR COLUMN ORDERING...JMW
          // [
          //   ...DonorDonationsListReportComponent.COLUMN_ORDER
          //     .map(colName => this.columnData.displayColumns.find(col => col.columnName === colName))
          //     .filter((col): col is DisplayColumn => !!col),
          //   ...this.columnData.displayColumns.filter(
          //     col => !DonorDonationsListReportComponent.COLUMN_ORDER.includes(col.columnName)
          //   )
          // ];

          this.defaultColumns = this.columnData.displayColumns.filter(x => x.isDefault);
          this.selectedColumns = this.defaultColumns; //.toMultiListOptionItems(this.defaultColumns);
          this.setDefaultValues(this.selectedColumns);
          
          this.generateEventTypes();
          this.cdr.detectChanges();
        }
      );
    } else {
      // temporary fix for always using code 215 when no code exists yet (e.g. page refresh)  
      setTimeout(() => this.initializeColumns(), 500);
    }
  }

  /**
   * Sets default values for column filters...
   * @param columns 
   */
  setDefaultValues(columns:DisplayColumn[]){
    columns.forEach(
      (itm:any) => {
        if(itm.columnName === "DonationDateBegin"){
          if(itm.defaultValue?.length){
            itm.filterModel.from = itm.defaultValue;
            itm.filterModel.op = FilterOperators.GreaterThenEqual;
          } else {
            const currentDate = new Date();
            const resultDate = new Date(currentDate);
            resultDate.setDate(currentDate.getDate() - (5 * 7));
            itm.filterModel.from = resultDate.getMonth() + "/" + resultDate.getDate() + "/" + resultDate.getFullYear();
            itm.filterModel.op = FilterOperators.GreaterThenEqual;
          }
      }
        if(itm.columnName === "DonationDateEnd"){
          const currentDate = new Date();
          itm.filterModel.from = (currentDate.getMonth() + 1) + "/" + currentDate.getDate() + "/" + currentDate.getFullYear();
          itm.filterModel.op = FilterOperators.LessThenEqual;
      }
    }
    );
      this.cdr.detectChanges();
  }

  getFilter(name:string):DisplayColumn{
    const filters:Array<DisplayColumn> = [];
    this.selectedColumns.forEach(
      (item:DisplayColumn) => {
        if(item.columnName === name){
          filters.push(item);
        }
      }
    );
    if(filters.length > 0 ){
      return filters[0];
    }
    console.debug("cant find filter for", name);
    return {} as DisplayColumn;
  }
  
  updateFilter(name:string, value:FilterModel):void{
    const ref:DisplayColumn = this.getFilter(name);
    ref.filterModel = value;
  }


  generateEventTypes():void{
    const evenTyp:DisplayColumn = this.columnData.displayColumns.filter((i:DisplayColumn) => i.columnName === "EventTypeDescription")[0];
    this.eventTypes = (evenTyp?.filterModel?.options || []).map(
      (item:any) => {
        return  { label: item.text, value: item.value }
      }
    );
  }


  /**
   Click handler that trigger a search if all the requirements are optinal to be able to search:
    1. at least one filter has a value to search against
    2. (Not done yet) all filters are validated.
   */ 
    onSearch() {  
      // const filterData: Array<any> = this.buildFilterData();
      const filterData: any = this.buildFilterData();
      this.showLoading = true;
      this.data = [];
      this.lastSearch = filterData;
      this.search(filterData);
    }
    
    search(filterData: MatchType[] = this.lastSearch): void {
      const _filters = JSON.stringify(filterData);
      const campaignId = this.model.selectedCampaign()?.campaignId;
      if (!campaignId) return;
    
      this.lastSearch = filterData;
      this.showLoading = this.searchPerformed = true;
      this.cd.detectChanges();
    
      this.fallsBackApi = false;
    
      const api$ = this.searchService.search(this.dataType, _filters).pipe(
        shareReplay({ bufferSize: 1, refCount: true }),
        catchError(err => {
          console.error('Search error', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Fetching data failed.',
            life: 0
          });
          return EMPTY;
        })
      );
    
      const fallback$ = timer(5000).pipe(
        switchMap(() => {
          return new Promise((resolve) => {
            this.ngZone.run(() => {
              this.confirmationService.confirm({
                message: 'The report is taking longer than usual.',
                header: 'Campaign Report Export',
                acceptLabel: 'Email',
                rejectLabel: 'Cancel',
                rejectButtonStyleClass: 'p-button-outlined',
                accept: () => {
                  this.fallsBackApi = true;
                  this.showLoading = false;
    
                  this.searchService.SendHangfireEmail(campaignId,filterData, 'DonorDonations')
                    .pipe(
                      catchError(err => {
                        console.error('Fallback error', err);
                        this.messageService.add({
                          severity: 'error',
                          summary: 'Error',
                          detail: 'Fallback failed.',
                          life: 0
                        });
                        return EMPTY;
                      })
                    )
                    .subscribe();
    
                  resolve('fallback'); 
                },
                reject: () => {
                  resolve('continue'); 
                }
              });
            });
          });
        }),
        switchMap(result => {
          if (result === 'fallback') return EMPTY;
          return api$;
        })
      );
    
      race(api$, fallback$).subscribe(data => {
        if (this.fallsBackApi) return; 
        this.showLoading = false;
        this.data = data;
        this.searchPerformed = true;
        this.cd.detectChanges();
      });
    }
  

  // sanitizeFilters(filters: MatchType[]): MatchType[] {
  //   if (!Array.isArray(filters)) return [];
  
  //   return filters.filter(f => f && f.Value !== null && f.Value !== undefined);
  // }
  

  /**
   * Using a function for this in case we need to do any standardized name formatting.
   * @param val 
   * @returns 
   */
  fieldName(val:string){
    return val;
  }


  /***
   * OVERRIDE THIS FUNCTION.
   * This should set filtering custom to the implementation.(?)
   */
  buildFilterData(): Array<MatchType> {
    const _filters:any = {};

    // set match type for the implicit campaign selected by the user for the current session...
    const campaignMatch:MatchType = new MatchType();
    campaignMatch.MatchMode = "equals";
    campaignMatch.Value = this.model.selectedCampaign()?.campaignId.toString();
    // the back end search current implementation takes this on the url whereas all other params are in the JSON...
    _filters.CampaignId = campaignMatch;
    const _thisRef = this;
    Object.keys(this.filters).forEach(function(key,index) {
          const filter:MatchType = new MatchType();
          const ref = _thisRef.filters[key] as DisplayColumn;
          filter.Value = ref.filterModel.from === "" ? null : ref.filterModel.from ;
          filter.MatchMode = ref.filterModel.op;
          _filters[ref.columnName] = filter;
    });
    // all normalized into a MatchType array...
    return _filters;
  }

  // Add event stuff =================================================================================================================
  
  initEventModel(){
    this.addEventModel = new EventModel();
    this.showAddEventModal = true;
  }

  addEvent(){
    const id:number = this.model.selectedCampaign()?.campaignId || -1;
    if(id !== -1){
      this.eventsService.createEvent(this.addEventModel, id).subscribe(
        (data:any) => { 
          console.debug(data);
          this.showAddEventModal = false;
          this.search();
        }
      );
    }
  }


  // END LIFECYCLE METHODS ===========================================================================================================
  
  
  closeActionDialog(){
    this.confirmAction = null;
    this.showConfirmModal = false;
  }

  
  
  openActionDialog(item:any, action:string){
    this.confirmAction = action;
    this.lastClicked = item;
    this.showConfirmModal = true;
  }

  doSelectedAction(){
  }

  toggleMenu(col:DisplayColumn){
    col.filterModel.isMenuOpen = !col.filterModel.isMenuOpen;
  }

  resetFilters() {
    this.selectedColumns.forEach(i => {
      if(i.filterModel.options?.length || 
        (i.displayColumnType.columnType === "AmountFilter" || i.displayColumnType.columnType === "DateFilter")){
        i.filterModel.from = "";
        i.filterModel.to = "";
        i.filterModel.op = "equals";
      } else {
        i.filterModel.from = "";
        i.filterModel.to = "";
        i.filterModel.op = "contains";
      }
    });
    this.data = new Array<DisplayColumn>();
  }


  check(i:DisplayColumn){
    this.howManyChecked();
    if(this.numberOfItemsSelected === this.data.length){
      this.allItemsChecked = true;
    } else {
      this.allItemsChecked = false;
    }
  }

  checkAll(){
    this.data.forEach(
      (i:DisplayColumn) => {
        i.isChecked = this.allItemsChecked;
      }
    );
    if(!this.allItemsChecked){
      this.numberOfItemsSelected = 0;
    } else {
      this.numberOfItemsSelected = this.data.length;
    }
  }
  
  getChecked(){
    this.checkedColumns  = this.data.filter(
      (i:DisplayColumn) => i.isChecked
    );
    return this.checkedColumns;
  }

  howManyChecked(){
    this.numberOfItemsSelected = this.getChecked().length;
    return this.numberOfItemsSelected;
  }

  selectedListString(){
    return this.checkedColumns.map((i:any) => i.EventCode).join(", ");
  }

  performSelectedOperation(){
    const ids:Array<number> = [];
    let action:string|null = null;
    const sendingItems:any = this.getChecked();
    if(this.lastClicked !== null){
      ids.push(this.lastClicked.EventID);
    } else {
      ids.push(...sendingItems.map((i:any) => i.EventID));
    }
    if(this.confirmAction)this.eventsService.batch(this.confirmAction, ids).subscribe(
      (data:any) => {
        console.debug("SUccess", data);
        this.messageService.add({ severity: 'success', summary: 'Your events have been updated' });
        this.closeActionDialog();
        this.onSearch();
      },
      (error:any) => {
        console.debug("failure", error);
        this.messageService.add({ severity: 'error', summary: 'There was in issue with updating one or more events' });
        this.closeActionDialog();
      }
    );
  }

  pageForward() {
    (this.document.getElementsByClassName("p-paginator-next")[0] as HTMLAnchorElement).click()
  }



  pageBack() {
    (this.document.getElementsByClassName("p-paginator-prev")[0] as HTMLAnchorElement).click()
  }

  popupMenuClickHandler(col:DisplayColumn, op:any){
    console.debug(1)
    col.filterModel.op = op.value; 
    if(col.filterModel.op !== 'between'){col.filterModel.isMenuOpen = false}
  }

  toggleSelectedLabels() {
    this.isExpandedView = !this.isExpandedView;
    // turn on or off...
  }



  /**
   * 
   * @param start 
   * @param maxResults 
   */
  updatePagingModel(start: number, maxResults: number = 10) {
    this.pagingModel.maxResults = maxResults;
    this.pagingModel.startRow = start;
    this.dataViewUpdate.emit(this.pagingModel);
  }



  pageChange(event: TablePageEvent) {
    this.updatePagingModel(event.first, event.rows);
  }


  convertLookupItemsToSelectItems(lookupItems: LookupFilter[]): SelectItem[] {
    return lookupItems.map((item: LookupFilter) => ({ value: item.value, label: item.label }));
  }
  
  toMultiListOptionItems(collection:any):any[] {
    return collection.map((item: any) => ({ value: item.id, label: item.columnName }));
  }



  getMatchMode(column: any): string {
    if(column.displayColumn){
      const {displayColumnType} = column;
      const {columnType} = displayColumnType;
      if (columnType === "TextFilter" || columnType === "IDFilter" )
        return 'equals';
      if (columnType === "AmountFilter")
        return 'gt';
      else
        return 'startsWith';
    } else {
      return 'equals';
    }
  }
  



  restrictNonNumeric(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Prevent non-numeric input
    }
  }



  onExportToExcel() {
    exportToExcel(this.resultstable.value || [],"Donor Donations List");          
  }



  onCancel(): void {
    this.messageService.add({ severity: 'info', summary: 'Cancelled', detail: 'Selection cancelled.' });
  }
  
}
